import type { DatasetEditorTab, QueryBuilderMode } from "metabase/redux/store";
import type { Path } from "metabase/router";

type LocationQBModeResult = {
  queryBuilderMode: QueryBuilderMode;
  datasetEditorTab?: DatasetEditorTab;
};

export function getQueryBuilderModeFromLocation(
  location: Partial<Path>,
): LocationQBModeResult {
  const { pathname } = location;
  const lastPathSegment = pathname?.split("/").pop();

  if (lastPathSegment === "notebook") {
    return {
      queryBuilderMode: "notebook",
    };
  }
  if (
    lastPathSegment === "query" ||
    lastPathSegment === "metadata" ||
    lastPathSegment === "columns"
  ) {
    return {
      queryBuilderMode: "dataset",
      datasetEditorTab: lastPathSegment,
    };
  }
  return {
    queryBuilderMode: "view",
  };
}
